export enum JobStatus {
  Scheduled = 1,
  InProgress,
  Success,
  Failed,
}
